import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link, Routes, useLocation } from 'react-router-dom';
import Privacy from './Privacy.js';
import Terms from './Terms.js';
import Guidelines from './Guidelines.js';
import Safety from './Safety.js';
import './App.css';


function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMobileOpen(false);

  return (
    <>
      <nav className="navbar">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          Scion Development
        </Link>

        <div className="navbar-links">
          <Link to="/" className="navbar-link">Home</Link>
          <Link to="/privacy" className="navbar-link">Privacy</Link>
          <Link to="/terms" className="navbar-link">Terms</Link>
          <a href="mailto:support@scion-development.com" className="navbar-contact">
            Contact
          </a>
        </div>

        <button
          className="navbar-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`navbar-mobile ${mobileOpen ? 'open' : ''}`}>
        <Link to="/" className="navbar-link" onClick={closeMenu}>Home</Link>
        <Link to="/privacy" className="navbar-link" onClick={closeMenu}>Privacy</Link>
        <Link to="/terms" className="navbar-link" onClick={closeMenu}>Terms</Link>
        <Link to="/guidelines" className="navbar-link" onClick={closeMenu}>Guidelines</Link>
        <a href="mailto:support@scion-development.com" className="navbar-contact" onClick={closeMenu}>
          Contact
        </a>
      </div>
    </>
  );
}

function Home() {
  return (
    <>
      {/* Hero */}
      <section className="hero">
        <div className="fade-in">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            Software Studio
          </div>
        </div>

        <h1 className="hero-title fade-in fade-in-delay-1">
          We build software<br />people love
        </h1>

        <p className="hero-subtitle fade-in fade-in-delay-2">
          Small team, big ideas. We design and ship software from Paris — focused on solving real problems.
        </p>
      </section>


      {/* About */}
      <section className="about-section fade-in fade-in-delay-3">
        <div className="section-title">About</div>
        <p className="about-text">
          Scion Development is an independent software studio. We focus on products that connect people and solve real problems.
        </p>
        <div className="about-location">
          <span role="img" aria-label="pin">📍</span>
          Paris, France
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-left">
          &copy; {new Date().getFullYear()} Scion Development SARL
        </div>
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy</Link>
          <Link to="/terms" className="footer-link">Terms</Link>
          <Link to="/guidelines" className="footer-link">Guidelines</Link>
          <a href="mailto:support@scion-development.com" className="footer-link">Contact</a>
        </div>
      </footer>
    </>
  );
}

function ExileViewRedirect() {
  useEffect(() => {
    // Extract origin from state param (format: "nonce|origin")
    const params = new URLSearchParams(window.location.search);
    const state = params.get('state') || '';
    const parts = state.split('|');
    const origin = parts.length > 1 ? parts[1] : 'https://exileview.web.app';
    window.location.replace(origin + '/oauth/callback' + window.location.search);
  }, []);
  return <p style={{ color: '#888', textAlign: 'center', marginTop: '4rem' }}>Redirecting to ExileView...</p>;
}

function App() {
  return (
    <Router>
      <div className="app-container">
        <div className="bg-glow">
          <div className="bg-glow-orb-1" />
          <div className="bg-glow-orb-2" />
        </div>

        <Navbar />

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/guidelines" element={<Guidelines />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/exileview" element={<ExileViewRedirect />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
